// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__2q_Uu","select":"Select_select__1Dulx","error":"Select_error__34s-1"};